/**
 * Detecta si la guía se está viendo dentro del editor de Magic Patterns (vista previa del staff).
 * El sitio publicado se abre directamente, sin estar incrustado en magicpatterns.com,
 * así que ahí devuelve false y el panel de verificación no existe para los jugadores.
 *
 * Nota: es una ocultación de interfaz, no una contraseña. Los archivos CSV siguen
 * siendo públicos en su dirección de descarga.
 */
const EDITOR_HOST = /(^|\.)magicpatterns\.com$/i

function hostOf(url: string): string | undefined {
  try {
    return new URL(url).hostname
  } catch {
    return undefined
  }
}

function computeStaffView(): boolean {
  if (typeof window === 'undefined') return false
  if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) return true
  let embedded = false
  try {
    embedded = window.self !== window.top
  } catch {
    embedded = true // acceso bloqueado al padre = incrustado en otro dominio
  }
  if (!embedded) return false
  const ancestors = (window.location as Location & { ancestorOrigins?: DOMStringList }).ancestorOrigins
  if (ancestors && ancestors.length) {
    for (let i = 0; i < ancestors.length; i++) {
      const h = hostOf(ancestors[i])
      if (h && EDITOR_HOST.test(h)) return true
    }
    return false
  }
  const ref = hostOf(document.referrer)
  return !!ref && EDITOR_HOST.test(ref)
}

export const isStaffView = computeStaffView()
